// QES flow routes
import { routes } from './routes';

const mixinQES = {
  name: 'mixinQES',
  created() {
    Object.keys(routes).forEach((cName) => (this[cName] = routes[cName]));
  },
  components: {},
  methods: {
    // Check if user is in Chrome Desktop to see what message
    // and button shows in Successful view
    isChromeDesktop() {
      return (
        navigator?.userAgentData?.mobile != undefined &&
        !navigator?.userAgentData?.mobile &&
        navigator.userAgentData?.brands?.some(
          (b) => b.brand === 'Google Chrome'
        )
      );
    },
  },
  data() {
    return {};
  },
};

export default mixinQES;
